import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet-async";
import Pagination from "react-bootstrap/Pagination";
import { db } from "../config/firebaseConfig";
import { collection, getDocs } from "firebase/firestore";

const Portfolyom = () => {
  const [filter, setFilter] = useState("all");
  const [currentPage, setCurrentPage] = useState(1);
  const [projects, setProjects] = useState([]);
  const projectsPerPage = 8;

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "projects"));
        const projectsData = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        console.log("Firestore'dan gelen veriler:", projectsData); // Debugging
        setProjects(projectsData);
      } catch (error) {
        console.error("Projeler çekilirken hata oluştu:", error);
      }
    };

    fetchProjects();
  }, []);

  const filteredProjects =
    filter === "all"
      ? projects
      : projects.filter((project) => project.category === filter);

  const handleCategorySelect = (category) => {
    setFilter(category);
    setCurrentPage(1);
  };

  const indexOfLastProject = currentPage * projectsPerPage;
  const indexOfFirstProject = indexOfLastProject - projectsPerPage;
  const currentProjects = filteredProjects.slice(
    indexOfFirstProject,
    indexOfLastProject
  );

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const pageNumbers = [];
  for (
    let i = 1;
    i <= Math.ceil(filteredProjects.length / projectsPerPage);
    i++
  ) {
    pageNumbers.push(
      <Pagination.Item
        key={i}
        active={i === currentPage}
        onClick={() => paginate(i)}
      >
        {i}
      </Pagination.Item>
    );
  }

  return (
    <>
      <Helmet>
        <title>Portfolyo | Web Tasarım ve E-Ticaret Çalışmaları</title>
        <link rel="canonical" href="https://www.hacialikara.com/portfolyom" />
        <meta
          name="description"
          content="Çeşitli web tasarım ve e-ticaret projelerimi keşfedin. Yenilikçi ve kullanıcı dostu projelerle size özel çözümler sunuyorum."
        />
        <meta
          name="keywords"
          content="web tasarım, e-ticaret, portfolyo, projeler, web projeleri, tasarım, dijital çözümler"
        />
        <meta
          property="og:title"
          content="Portfolyo | Web Tasarım ve E-Ticaret Çalışmaları"
        />
        <meta
          property="og:description"
          content="Çeşitli web tasarım ve e-ticaret projelerimi keşfedin. Yenilikçi ve kullanıcı dostu projelerle size özel çözümler sunuyorum."
        />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="image/iconali.png" />
        <meta property="og:url" content="hacialikara.com/portfolyo" />
      </Helmet>

      <section id="portfolio" className="portfolio section">
        <div className="container section-title" data-aos="fade-up">
          <h2>Portfolyo</h2>
          <div className="title-shape">
            <svg viewBox="0 0 200 20" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M 0,10 C 40,0 60,20 100,10 C 140,0 160,20 200,10"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              ></path>
            </svg>
          </div>
          <p>Çalışmalarıma göz atın ve farklı projeler hakkında bilgi edinin.</p>
        </div>

        <div
          className="portfolio-filters-container"
          data-aos="fade-up"
          data-aos-delay="200"
          style={{ marginBottom: "20px" }}
        >
          <ul className="portfolio-filters isotope-filters">
            <li
              className={`filter-item ${filter === "all" ? "filter-active" : ""}`}
              onClick={() => handleCategorySelect("all")}
            >
              Tüm Çalışmalar
            </li>
            <li
              className={`filter-item ${filter === "web design" ? "filter-active" : ""}`}
              onClick={() => handleCategorySelect("web design")}
            >
              Web Tasarım
            </li>
            <li
              className={`filter-item ${filter === "e-commerce" ? "filter-active" : ""}`}
              onClick={() => handleCategorySelect("e-commerce")}
            >
              E-Ticaret
            </li>
          </ul>
        </div>

        <div
          className="row g-4 isotope-container"
          data-aos="fade-up"
          data-aos-delay="300"
        >
          {currentProjects.map((project) => (
            <div
              key={project.id}
              className={`col-lg-6 col-md-6 portfolio-item isotope-item filter-${
                project.category ? project.category.replace(" ", "-") : "unknown"
              }`}
            >
              <div className="portfolio-card">
                <div className="portfolio-image">
                  <img
                    src={project.image}
                    className="img-fluid"
                    alt={project.title}
                    loading="lazy"
                  />
                  <div className="portfolio-overlay">
                    <div className="portfolio-actions">
                      <a
                        href={project.image}
                        className="glightbox preview-link"
                        data-gallery={`portfolio-gallery-${
                          project.category ? project.category.replace(" ", "-") : "unknown"
                        }`}
                      >
                        <i className="bi bi-eye"></i>
                      </a>
                      <a
                        href={project.link}
                        className="details-link"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="bi bi-arrow-right"></i>
                      </a>
                    </div>
                  </div>
                </div>
                <div className="portfolio-content">
                  <span className="category">
                    {project.category === "web design"
                      ? "Web Tasarım"
                      : project.category === "e-commerce"
                      ? "E-Ticaret"
                      : "Bilinmeyen Kategori"}
                  </span>
                  <h3>{project.title}</h3>
                  <p>{project.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="d-flex justify-content-center mt-4">
          <Pagination>
            <Pagination.Prev
              onClick={() =>
                setCurrentPage((prev) => (prev > 1 ? prev - 1 : prev))
              }
              disabled={currentPage === 1}
            />
            {pageNumbers}
            <Pagination.Next
              onClick={() =>
                setCurrentPage((prev) =>
                  prev < pageNumbers.length ? prev + 1 : prev
                )
              }
              disabled={currentPage === pageNumbers.length}
            />
          </Pagination>
        </div>
      </section>
    </>
  );
};

export default Portfolyom;